Wee.fn.make('news', {
	init: function() {
		var $newsCat = $('ref:newsCats'),
			priv = this.$private;

		$.screen.map([
			{
				max: 3,
				init: false,
				callback: function() {
					$newsCat.insertAfter($('ref:newsShare'));
				}
			},
			{
				min: 4,
				callback: function() {
					$newsCat.insertAfter($('ref:newsContent'));
				}
			}
		]);

		Wee.flushHeights.$private.size('newsTitle', 'newsTitle');

		priv.shortCodes();
		priv.initDropdowns();
		priv.initEvents();
	}
}, {
	/**
	 * Init dropdowns
	 *
	 * @private
	 */
	initDropdowns: function() {
		var years = Wee.fn.dropdown(),
			categories = Wee.fn.dropdown(),
			routeLength = $.routes.segments().length,
			isYear = /^\d{4}$/.test($.routes.segments(1));

		years.init({
			selector: 'ref:yearsDropdown',
			isSelected: isYear,
			appPrefix: 'years',
			rootModifier: '-news',
			placeholder: 'Year'
		});

		categories.init({
			selector: 'ref:categoriesDropdown',
			isSelected: (routeLength > 1 && this.notPaginated(1) && isYear === false) || (routeLength > 2 && this.notPaginated(2) && isYear),
			appPrefix: 'categories',
			rootModifier: '-news -cat',
			placeholder: 'Category'
		});
	},

	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		$('ref:newsDropdown').on('change', function() {
			var segments = $('ref:newsDropdown').map(function(el) {
				return $(el).val();
			});

			if (segments[0] && segments[1] === '') {
				segments.splice(1, 2);
			} else if (segments[1] && segments[0] === '') {
				segments.splice(0, 1);
			}

			$.history.go({
				path: '/news' + (segments[0] ? '/' + segments.join('/') : '')
			});
		});
	},

	/**
	 * Check if a segment is a paginated page
	 *
	 * @param {number} segment
	 * @returns {boolean}
	 */
	notPaginated: function(segment) {
		return /^P[\d]+$/.test($.routes.segments(segment)) === false;
	},

	/**
	 * Init short codes
	 *
	 * @private
	 */
	shortCodes: function() {
		var $container = $('ref:shortcodeContainer');

		if ($container.length) {
			var $content = $container,
				html = $content[0].innerHTML,
				results = html.match(/\[video:https:\/\/youtu.be\/(.*)]/),
				videoHTML;

			if (results) {
				videoHTML = Wee.view.render('video', {
					src: results[1]
				});
			}

			$content[0].innerHTML = html.replace(/\[video:(.*)]/, videoHTML);
		}
	}
});